import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { useHistory } from 'react-router-dom'
import {
  List,
  Filter,
  TextField,
  useListRepository,
  useFilter,
  DatePicker,
  Checkbox
} from 'elentari'
import abbreviate from 'abbreviate-name'
import SolicitacoesRepository from '../../Solicitacoes/SolicitacoesRepository'
import moment from 'moment'
import UsuarioAutocomplete from '../../Usuarios/UsuarioAutocomplete'
import CentroCustoAutocomplete from '../../CentrosCusto/CentroCustoAutocomplete'
import MercadoriaAutocomplete from '../../Mercadorias/MercadoriaAutocomplete'
import { IconButton } from '@material-ui/core'
import BarChartIcon from '@material-ui/icons/BarChart'
import { secondsToStringTimer } from '../../../utils/Formatter'
import EmpresaSelect from '../../Empresa/EmpresaSelect'

const TempoSolicitacoesFilter = () => {
  const filter = useFilter({})

  const detailedFilter = () => (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Criação"
          name="createdAt"
        />
      </Grid>
      <Grid item xs={3}>
        <Field
          fullWidth
          component={DatePicker}
          label="Data Término"
          name="dataTermino"
        />
      </Grid>
      <Grid item sm={3} xs={12}>
        <Field
          fullWidth
          name="mercadoriaId"
          label="Mercadoria"
          component={MercadoriaAutocomplete}
        />
      </Grid>
      <Grid item xs={3}>
        <Field
          fullWidth
          component={Checkbox}
          label="Com troca de responsável"
          name="trocaResponsavel"
        />
      </Grid>
    </Grid>
  )

  return (
    <Filter
      {...filter}
      detailedFilter={detailedFilter()}
      labels={{
        detailedFilter: 'Busca avançada',
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={2} container>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="motorista"
            label="Motorista"
            component={TextField}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="centroCustoId"
            label="Centro de custo"
            component={CentroCustoAutocomplete}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <EmpresaSelect />
        </Grid>
        <Grid item sm={3} xs={12}>
          <Field
            fullWidth
            name="responsavelId"
            label="Responsável"
            component={UsuarioAutocomplete}
            realm="analistaadmin"
          />
        </Grid>
      </Grid>
    </Filter>
  )
}

export default function TableSolicitacaoTrocaAnalista(props) {
  const history = useHistory()

  const listOptions = {
    defaultOrder: 'createdat desc',
    fields: {
      id: {
        label: 'Id'
      },
      tempoaberto: {
        label: <span style={{ whiteSpace: 'nowrap' }}>Tempo Aberto</span>,
        format: tempo => secondsToStringTimer(tempo),
        align: 'center'
      },
      temporeaberto: {
        label: <span style={{ whiteSpace: 'nowrap' }}>Tempo Reaberto</span>,
        format: tempo => secondsToStringTimer(tempo),
        align: 'center'
      },
      tempoanalise: {
        label: <span style={{ whiteSpace: 'nowrap' }}>Tempo Análise</span>,
        format: tempo => secondsToStringTimer(tempo),
        align: 'center'
      },
      temporeanalise: {
        label: <span style={{ whiteSpace: 'nowrap' }}>Tempo Reanálise</span>,
        format: tempo => secondsToStringTimer(tempo),
        align: 'center'
      },
      tempopendente: {
        label: <span style={{ whiteSpace: 'nowrap' }}>Tempo Pendente</span>,
        format: tempo => secondsToStringTimer(tempo),
        align: 'center'
      },
      tempopendentegestor: {
        label: (
          <span style={{ whiteSpace: 'nowrap' }}>
            Tempo Pendente Monitoramento
          </span>
        ),
        format: tempo => secondsToStringTimer(tempo),
        align: 'center'
      },
      trocaResponsavel: {
        label: 'Troca de Responsável',
        format: trocaResponsavel => (trocaResponsavel ? 'Sim' : 'Não'),
        noOrder: true,
        align: 'center'
      },
      detalhes: {
        label: 'Detalhes',
        format: id => (
          <IconButton
            onClick={() =>
              history.push(`/paineis-solicitacoes/tempo-solicitacao/${id}`)
            }
            color="primary"
          >
            <BarChartIcon />
          </IconButton>
        ),
        noOrder: true,
        align: 'center'
      },
      motorista: {
        label: 'Motorista',
        format: motorista => (motorista ? abbreviate(motorista.nome) : '-'),
        noOrder: true,
        align: 'center'
      },
      createdat: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm'),
        align: 'center'
      },
      datatermino: {
        label: 'Data Término',
        format: data => (data ? moment(data).format('DD/MM/YYYY HH:mm') : '-'),
        align: 'center'
      },
      mercadoria: {
        label: 'Mercadoria',
        format: mercadoria => (mercadoria ? mercadoria.descricao : '-'),
        noOrder: true,
        align: 'center'
      },
      centroCusto: {
        label: 'Centro de Custo',
        format: centroCusto => (centroCusto ? centroCusto.descricao : '-'),
        noOrder: true,
        align: 'center'
      },
      responsavel: {
        label: 'Responsável',
        format: responsavel => (responsavel ? responsavel.nome : '-'),
        noOrder: true,
        align: 'center'
      }
    }
  }

  const listHook = useListRepository({
    repository: SolicitacoesRepository,
    path: 'solicitacoes',
    defaultSort: 'createdat desc',
    cancelPreviousRequest: true
  })

  listHook.state.list = listHook.state.list.map(item => ({
    ...item,
    detalhes: item.id,
    tempoAberto: item.logSolicitacaoTempoStatus.tempoAberto,
    tempoReaberto: item.logSolicitacaoTempoStatus.tempoReaberto,
    tempoAnalise: item.logSolicitacaoTempoStatus.tempoAnalise,
    tempoReanalise: item.logSolicitacaoTempoStatus.tempoReanalise,
    tempoPendente: item.logSolicitacaoTempoStatus.tempoPendente,
    tempoPendenteGestor: item.logSolicitacaoTempoStatus.tempoPendenteGestor
  }))

  return (
    <>
      <TempoSolicitacoesFilter />
      <List
        {...props}
        {...listHook}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        onClickNew={null}
        onClickEdit={null}
        removeItem={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}
